var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoData = function SvgNoData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459.814,
    height: 411.224,
    viewBox: "0 0 459.814 411.224",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_hay_resultados",
    "data-name": "No hay resultados",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(33.904 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 205.612,
    cy: 205.612,
    rx: 205.612,
    ry: 205.612,
    fill: "#eff9f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(13.487 34.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M1128.806,275.431a39.886,39.886,0,1,0-22.553,35.946c4.6,2.357,12.123,6.063,12.123,6.063l.788-.946-3.21-11.735A39.8,39.8,0,0,0,1128.806,275.431Z",
    transform: "translate(-1048.989 -235.522)",
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(31.923 35.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(60.468 34.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(60.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1280.744,296.064l7.7,26.947-8.647-8.962-5.505-19.577q1.546-.546,2.938-.981Z",
    transform: "translate(-1274.294 -293.49)",
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(15.862 18.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M1236.048,337.218l3.252,13.6-36.766-14.967.346-1.895,2.068-11.239,6.487,3.024Z",
    transform: "translate(-1202.534 -322.72)",
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(0 86.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M1192.356,441.728a27.462,27.462,0,0,1,.864,6.974c0,8.61-3.666,15.6-8.2,15.6s-8.19-6.987-8.19-15.6,3.666-15.6,8.19-15.6C1188.233,433.1,1191.011,436.612,1192.356,441.728Z",
    transform: "translate(-1176.834 -433.1)",
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(100.182 46.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M1404,408.336a9.046,9.046,0,0,1-2.228,11.776,205.626,205.626,0,0,1-52.054,28.8h-.006a52.761,52.761,0,0,1,22.663-80.667C1384.5,377.008,1397.633,397.579,1404,408.336Zm-23.558,13.27a4.524,4.524,0,0,0,2.1-6.487l-13.128-21.873a4.51,4.51,0,0,0-6.45-1.389l-1.247.864a4.519,4.519,0,0,0-1.876,4.456l4.246,25.336a4.523,4.523,0,0,0,6.234,3.413Z",
    transform: "translate(-1339.154 -368.25)",
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(54.488 60.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1301.283,452.041l-25.774,13.374a4.561,4.561,0,0,1-6.314-2.321,52.333,52.333,0,0,1-2.679-32.02c5.042-20.546,10.789-27.144,24.792-34.729a56.63,56.63,0,0,1,14.5-5.326,67.609,67.609,0,0,0-4.524,61.021Zm-13.177-10.69a1.807,1.807,0,0,0,.617-2.716l-.154-.2a1.8,1.8,0,0,0-2.3-.494l-10.085,5.413a1.814,1.814,0,0,0,1.679,3.216Z",
    transform: "translate(-1265.117 -391.02)",
    fill: "#daefee"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(309.406 201.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M1590.525,575.65a2.681,2.681,0,0,1-1.038-.21l-9.312-3.894.715-1.708,9.314,3.894a.839.839,0,0,0,1.021-.3l1.2-1.785a.849.849,0,0,0-.23-1.17l-7.918-5.3,1.031-1.538,7.918,5.3a2.7,2.7,0,0,1,.736,3.739l-1.207,1.788A2.7,2.7,0,0,1,1590.525,575.65Z",
    transform: "translate(-1580.175 -563.634)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(199.841 238.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M1432.964,632.824c-1.943-.2-3.921-.458-6.048-.8-3.756-.607-7.04-1.34-9.183-1.839-1.224-.284-2.4-.562-3.541-.835-4.39-1.037-8.032-1.961-11.538-3.093l.569-1.763c3.447,1.114,7.049,2.026,11.4,3.054,1.142.272,2.313.549,3.533.833,2.117.492,5.36,1.216,9.06,1.815,2.091.339,4.033.6,5.938.789Z",
    transform: "translate(-1402.653 -624.492)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(168.521 282.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M1392.812,707.058a89.39,89.39,0,0,1-26.89-4.114,92.7,92.7,0,0,1-14.015-5.71l.836-1.653a90.8,90.8,0,0,0,13.734,5.6,87.85,87.85,0,0,0,15.843,3.408,89.2,89.2,0,0,0,14.867.513l.091,1.849Q1395.048,707.057,1392.812,707.058Z",
    transform: "translate(-1351.907 -695.581)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(139.104 226.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1333.9,662.5l-.24-.12a103.661,103.661,0,0,1-18.5-12.128,102.234,102.234,0,0,1-9.267-8.426l-1.651-1.7,2.365.126c.15.01,15.033.691,25.384-8.826,6.355-5.842,9.744-14.306,10.074-25.155l.053-1.747,1.416,1.026a85.039,85.039,0,0,0,9.518,5.977,73.246,73.246,0,0,0,12.5,5.321l.516.167.107.531c2.5,12.315.829,22.523-4.96,30.338-9.455,12.764-26.332,14.519-27.046,14.588ZM1308.785,642.1a100.45,100.45,0,0,0,7.536,6.7,102.081,102.081,0,0,0,17.927,11.793c2.153-.273,17.146-2.559,25.485-13.828,5.375-7.264,6.964-16.793,4.729-28.329a74.934,74.934,0,0,1-12.288-5.284,87.132,87.132,0,0,1-8.336-5.121c-.64,10.56-4.2,18.885-10.607,24.765C1324.67,640.663,1313.527,641.936,1308.785,642.1Z",
    transform: "translate(-1304.244 -604.523)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(168.561 220.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M1360.717,603.269a87,87,0,0,1-8.746-7.274l1.275-1.343a85.216,85.216,0,0,0,8.56,7.119Z",
    transform: "translate(-1351.971 -594.652)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(209.681 243.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M1418.6,682.539l3.736-1.956c2.208-1.155,21.462-12.014,17.929-37.174a54.053,54.053,0,0,0-1.985-8.634l-.423-1.344,1.4.146a79.571,79.571,0,0,0,19.565-.254,25.893,25.893,0,0,0,7.016-1.829l.48-.226.437.3c.154.106,15.267,10.817,6.149,32.4l-.1.225-.194.149c-1.833,1.406-3.813,2.785-5.887,4.1-1.382.875-2.725,1.677-4.1,2.451a90.156,90.156,0,0,1-19.333,8.038,91.662,91.662,0,0,1-20.481,3.392Zm21.849-46.988a54.946,54.946,0,0,1,1.65,7.6c2.964,21.112-9.4,32.657-15.669,37.064a90.022,90.022,0,0,0,16.356-3.059,88.327,88.327,0,0,0,18.934-7.873c1.35-.757,2.664-1.543,4.018-2.4,1.955-1.24,3.823-2.538,5.557-3.859,7.607-18.287-2.886-27.822-5.18-29.626a29.118,29.118,0,0,1-7.025,1.756A80.542,80.542,0,0,1,1440.445,635.551Z",
    transform: "translate(-1418.596 -631.267)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(262.572 215.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M1505.418,647.541l-1.126-1.47c1.884-1.442,3.2-2.588,4.027-3.325,6.1-5.474,12.4-11.135,14.846-20.81a32.007,32.007,0,0,0,.97-11.04l0-.049a25.6,25.6,0,0,0-.454-2.911,25.093,25.093,0,0,0-2.172-6.153,22.9,22.9,0,0,0-10.15-10.466l-.057-.029a26.266,26.266,0,0,0-3.259-1.373,23.252,23.252,0,0,0-2.678-.729l.374-1.813a25.231,25.231,0,0,1,2.9.788,27.983,27.983,0,0,1,3.487,1.468l.061.031a24.725,24.725,0,0,1,10.975,11.285,26.942,26.942,0,0,1,2.333,6.6,27.611,27.611,0,0,1,.491,3.162l0,.053a33.78,33.78,0,0,1-1.021,11.627c-2.58,10.223-9.394,16.34-15.407,21.737C1508.7,644.884,1507.35,646.061,1505.418,647.541Z",
    transform: "translate(-1504.292 -587.371)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(245.277 215.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M1492.318,607.633a3.712,3.712,0,0,0-.691-1.893,4.641,4.641,0,0,0-4.668-1.623,2.264,2.264,0,0,0-.3.1,3.038,3.038,0,0,0-.523.315,6.816,6.816,0,0,1-1.714.9c-.856.315-2.816,1.036-4.473.478-2.688-.9-3.972-4.967-3.618-8.223.586-5.51,5.965-8.588,7.6-9.4A16.753,16.753,0,0,1,1495,587.105l-.372,1.815a14.926,14.926,0,0,0-9.874,1.026c-1.013.5-6.085,3.248-6.584,7.941-.271,2.5.683,5.708,2.366,6.269a5.738,5.738,0,0,0,3.228-.453,5.125,5.125,0,0,0,1.318-.689,4.65,4.65,0,0,1,.849-.5,4.259,4.259,0,0,1,.527-.184,6.443,6.443,0,0,1,6.666,2.314,5.576,5.576,0,0,1,1.039,2.813Z",
    transform: "translate(-1476.27 -586.679)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(256.919 236.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1495.925,628.995l-.791-1.674a7.4,7.4,0,0,0,3.712-3.337,7.156,7.156,0,0,0,.692-3.452l1.845-.165a9.114,9.114,0,0,1-.871,4.425A9.29,9.29,0,0,1,1495.925,628.995Z",
    transform: "translate(-1495.134 -620.366)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(129.67 249.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M1300.043,655.923c-1.575-1.621-3.129-3.33-4.62-5.081a103.765,103.765,0,0,1-6.465-8.433l1.526-1.049a101.382,101.382,0,0,0,6.348,8.281c1.464,1.719,2.991,3.4,4.538,4.992Z",
    transform: "translate(-1288.958 -641.36)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(138.959 288.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M1305.645,751.911l-1.636-.868c3.2-6.027,8.451-11.756,15.354-18.5,3.317-3.246,7.141-6.842,11.568-11.006q2.712-2.55,5.724-5.392c.934-.88,1.893-1.812,2.851-2.771,2.584-2.583,5.16-5.365,7.656-8.268l1.4,1.207c-2.526,2.938-5.133,5.755-7.751,8.37-.971.971-1.943,1.917-2.889,2.809q-3.015,2.849-5.727,5.394c-4.421,4.157-8.239,7.748-11.543,10.981C1313.878,740.49,1308.73,746.1,1305.645,751.911Z",
    transform: "translate(-1304.009 -705.103)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(112.425 324.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M1278.282,798.769c-3.8,0-7.4-2.319-11.553-7.307a21.887,21.887,0,0,1-3.706-6.888,43.541,43.541,0,0,1-1.234-21.386l1.822.335a41.631,41.631,0,0,0,1.161,20.446,20.065,20.065,0,0,0,3.38,6.309c5.884,7.072,9.562,7.178,12.654,6.242,2.8-.846,2.792-6.124,2.553-8.085l-.012-.1.009-.1c.057-.628.12-1.244.195-1.847a36.841,36.841,0,0,1,4-13.113l1.635.868a35.054,35.054,0,0,0-3.793,12.475c-.068.552-.127,1.116-.179,1.69.11,1.021.765,8.584-3.866,9.981A10.5,10.5,0,0,1,1278.282,798.769Z",
    transform: "translate(-1261.018 -763.188)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(113.196 276.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M1264.09,733.858l-1.823-.327a42.4,42.4,0,0,1,1.061-4.488,166.918,166.918,0,0,1,6.735-17.284c5.046-11.536,10.88-23.488,10.972-23.674h0s.37-.9.839-2.366l1.763.567c-.506,1.574-.9,2.521-.915,2.56-.082.17-5.918,12.123-10.962,23.653a165.485,165.485,0,0,0-6.656,17.066A40.434,40.434,0,0,0,1264.09,733.858Z",
    transform: "translate(-1262.267 -685.721)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(132.804 260.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M1295.8,676.346l-1.763-.569c1.058-3.277,2.717-9.684,1.95-15.782l1.837-.231C1298.635,666.217,1296.9,672.923,1295.8,676.346Z",
    transform: "translate(-1294.036 -659.763)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(210.744 231.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M1433.1,626.91c-.355-.442-.711-.9-1.067-1.366-2.406-3.119-4.652-6.209-6.832-9.4-.6,1.637-1.649,4.357-3.188,7.9l-1.7-.738c2.522-5.8,3.736-9.452,3.748-9.488l.594-1.8,1.053,1.573c2.48,3.7,5.028,7.245,7.79,10.825.349.452.7.9,1.044,1.337Z",
    transform: "translate(-1420.318 -612.016)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(235.286 281.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M1471.732,741.03a14.181,14.181,0,0,1-5.5-1.011,12.686,12.686,0,0,1-4.433-3.186,4.9,4.9,0,0,1-1.705-3.633,4.135,4.135,0,0,1,1.8-2.911,4.638,4.638,0,0,1,3.05-.585c.141.008.28.016.415.021,1.771.065,3.085-.525,5.265-1.494a13.292,13.292,0,0,0,1.773-.954,15.924,15.924,0,0,0,5.055-5.183,16.3,16.3,0,0,0,.961-1.978c.392-.988.673-1.94.944-2.861a33.67,33.67,0,0,0,.919-4.3c.376-2.283.7-4.254.857-5.818a14.4,14.4,0,0,0-.019-3.765,14.57,14.57,0,0,0-1.745-4.659c-.253-.485-.493-.942-.7-1.4-.432-.954-.9-1.929-1.439-2.98l1.65-.841c.548,1.076,1.031,2.076,1.475,3.056.188.413.415.849.656,1.31a14.221,14.221,0,0,1,1.965,9.465c-.162,1.623-.491,3.622-.871,5.935a35.522,35.522,0,0,1-.97,4.522c-.27.918-.576,1.956-1,3.033a18.071,18.071,0,0,1-1.077,2.213,17.845,17.845,0,0,1-5.664,5.819,15.163,15.163,0,0,1-2.015,1.083c-2.254,1-3.894,1.727-6.078,1.652-.151-.005-.306-.014-.463-.023a2.989,2.989,0,0,0-1.934.291,2.28,2.28,0,0,0-.957,1.505c-.059.743.452,1.373,1.241,2.25a10.742,10.742,0,0,0,3.759,2.708,14.159,14.159,0,0,0,6.924.771,45.7,45.7,0,0,0,6.939-.947,36.438,36.438,0,0,0,4.885-1.518,51.526,51.526,0,0,0,15.258-9.257c1.355-1.156,2.45-2.2,3.33-3.032,4.381-4.18,9.316-8.889,12.51-16.818a29.517,29.517,0,0,0,1.311-4.169l1.8.439a31.249,31.249,0,0,1-1.392,4.422c-3.343,8.3-8.654,13.368-12.921,17.439-.926.88-2.04,1.939-3.433,3.127a53.368,53.368,0,0,1-15.8,9.578,38.179,38.179,0,0,1-5.129,1.593,46.909,46.909,0,0,1-7.156.985C1473.3,740.983,1472.524,741.03,1471.732,741.03Z",
    transform: "translate(-1460.082 -693.489)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(293.305 260.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M1555.885,690.8l-1.8-.439c.5-2.029.97-4.544,1.57-7.728,1.571-8.333,2.346-12.954,1.366-18.8a26.471,26.471,0,0,0-.876-3.662l1.764-.562a28.092,28.092,0,0,1,.938,3.915c1.08,6.442.1,11.615-1.373,19.448C1556.872,686.189,1556.394,688.725,1555.885,690.8Z",
    transform: "translate(-1554.087 -659.615)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(282.017 235.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M1549.144,644.582c-.591-1.91-1.433-3.893-2.6-6.638l-.037-.088c-1.759-4.141-5.363-10.16-10.711-17.889l1.522-1.054c5.42,7.832,9.085,13.961,10.894,18.22l.037.087c1.186,2.8,2.043,4.815,2.661,6.814Z",
    transform: "translate(-1535.798 -618.913)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(254.723 184.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M1502.9,569.424a57.3,57.3,0,0,1-6.085-10.038,55.861,55.861,0,0,1-4.594-14.535,52.093,52.093,0,0,1-.642-8.881l1.852.025a50.2,50.2,0,0,0,.618,8.563,53.974,53.974,0,0,0,4.441,14.037,55.409,55.409,0,0,0,5.888,9.713Z",
    transform: "translate(-1491.576 -535.97)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(265.812 189.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M1517.424,572.351a19.68,19.68,0,0,1-6.064-7.758,22.663,22.663,0,0,1-1.817-10.138c0-.744.03-1.488.09-2.224a30.13,30.13,0,0,1,1.827-8.267c.014-.041.026-.076.043-.114l1.711.7-.025.072a28.224,28.224,0,0,0-1.71,7.749c-.057.7-.085,1.376-.085,2.066a21.085,21.085,0,0,0,1.652,9.386,17.861,17.861,0,0,0,5.489,7.044Z",
    transform: "translate(-1509.543 -543.849)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(273.693 119.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M1532.541,532.514a16.38,16.38,0,0,1-7.174-1.523,16.877,16.877,0,0,1-3.056-1.834l1.114-1.479a15.029,15.029,0,0,0,2.721,1.634c3.816,1.778,7.3,1.413,11,1.026a30.958,30.958,0,0,0,13.484-4.748c.125-.081.252-.164.379-.257a30.573,30.573,0,0,0,6.664-6.008c.489-.591.9-1.123,1.228-1.554a35.006,35.006,0,0,0,2.936-4.585,48.639,48.639,0,0,0,2.149-4.5c.472-1.143,1.186-2.874,1.875-5a44.664,44.664,0,0,0,2.154-16.8,40.487,40.487,0,0,0-1.66-9.126,69.53,69.53,0,0,0-3.534-8.966l-.082-.183a73.115,73.115,0,0,0-10.116-15.864c-.427-.518-.852-1.023-1.284-1.516a83.289,83.289,0,0,0-22.926-18.364c-.061-.032-.137-.074-.214-.116l-.189-.1.859-1.641c.078.041.154.083.23.125l.189.1a85.137,85.137,0,0,1,23.446,18.778q.662.755,1.318,1.555a74.985,74.985,0,0,1,10.374,16.277l.084.185a71.044,71.044,0,0,1,3.621,9.2,42.346,42.346,0,0,1,1.734,9.535,46.53,46.53,0,0,1-2.24,17.5c-.711,2.192-1.442,3.964-1.926,5.136a50.707,50.707,0,0,1-2.233,4.68,36.971,36.971,0,0,1-3.092,4.826c-.315.414-.748.976-1.273,1.611a32.323,32.323,0,0,1-7.027,6.341c-.121.09-.277.193-.435.295a32.806,32.806,0,0,1-14.275,5.033A46.46,46.46,0,0,1,1532.541,532.514Z",
    transform: "translate(-1522.311 -431.001)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(280.642 169.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M1540.132,519.977c-.051-.162-.112-.342-.185-.532a7.755,7.755,0,0,0-1.3-2.223,9.437,9.437,0,0,0-4.833-2.782c-.093-.029-.168-.049-.249-.069l.45-1.8c.116.029.225.058.342.1a11.052,11.052,0,0,1,5.708,3.361,9.607,9.607,0,0,1,1.608,2.753c.088.228.161.444.222.64Z",
    transform: "translate(-1533.57 -512.575)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(267.86 167.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M1525.608,513.023a58.593,58.593,0,0,0-12.133-2.039c-.2-.017-.377-.028-.548-.038l-.067,0,.116-1.848.066,0c.185.011.38.023.58.041a60.315,60.315,0,0,1,12.5,2.107Z",
    transform: "translate(-1512.86 -509.093)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(275.293 174.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M1534.272,550.22a9.78,9.78,0,0,1-4.561-1.087l-.154-.083c-.182-.1-.422-.23-.7-.394a8.288,8.288,0,0,1-3.346-3.7,6.832,6.832,0,0,1-.368-1.052,7.913,7.913,0,0,1,.347-4.907l1.725.673a6.066,6.066,0,0,0-.281,3.761,5.016,5.016,0,0,0,.271.778,6.464,6.464,0,0,0,2.619,2.869c.234.14.45.257.615.347l.145.079c3.739,1.944,7.814.12,8.974-.485.133-.072.277-.149.408-.231a10.756,10.756,0,0,0,3.11-2.763,12.257,12.257,0,0,0,1.791-3.275,11.832,11.832,0,0,0,.554-5.837,18.858,18.858,0,0,0-.8-3.171,13.769,13.769,0,0,0-3.177-5.554l-.094-.1c-.31-.323-.736-.767-1.275-1.231a15.188,15.188,0,0,0-1.206-.934,10.206,10.206,0,0,0-1.733-.951,8.167,8.167,0,0,0-3.786-.682,9.5,9.5,0,0,0-6.227,3.166l-.687-.621-.655-.655a11.321,11.321,0,0,1,7.453-3.738,9.995,9.995,0,0,1,4.63.828,11.984,11.984,0,0,1,2.05,1.124,16.956,16.956,0,0,1,1.367,1.058c.609.525,1.069,1,1.405,1.354l.093.1a15.7,15.7,0,0,1,3.6,6.263,20.714,20.714,0,0,1,.875,3.475,13.664,13.664,0,0,1-.645,6.738,14.118,14.118,0,0,1-2.061,3.769,12.559,12.559,0,0,1-3.622,3.222c-.145.091-.322.187-.5.283A13.919,13.919,0,0,1,1534.272,550.22Z",
    transform: "translate(-1524.904 -520.422)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(133.393 258.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M1296.575,660.4l-1.584-.96c.384-.634.75-1.249,1.086-1.841.388-.655.731-1.273,1.056-1.861l.075-.135,1.62.9-.074.135c-.334.6-.685,1.238-1.075,1.895C1297.343,659.121,1296.969,659.751,1296.575,660.4Z",
    transform: "translate(-1294.991 -655.604)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 117.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M1148.777,612.909a68.7,68.7,0,0,1-23.959-4.42c-.562-.206-1.076-.4-1.53-.581l-.265-.1a72.365,72.365,0,0,1-28.841-20.438c-3.106-3.693-10.382-12.344-13.679-25.095a52.644,52.644,0,0,1-1.238-6.37c-1.044-7.922.037-13.756,2-24.347a127.759,127.759,0,0,1,4.407-17.015,134.732,134.732,0,0,1,5.326-13.56c3.379-7.4,5.417-11.864,9.551-17.5,1.187-1.62,2.334-3.044,3.444-4.421a56.183,56.183,0,0,0,7.71-11.614c.33-.675.821-1.711,1.274-2.909a23.571,23.571,0,0,0,1.576-7.642l0-.085c.035-1.049.068-2.041.016-2.986a8.384,8.384,0,0,0-1.239-4.281,5.673,5.673,0,0,0-1.5-1.6c-.245-.188-.513-.379-.814-.594a41.483,41.483,0,0,1-4.68-3.822c-2.662-2.488-3.362-3.615-3.724-4.825a8.929,8.929,0,0,1,.949-6.745c2.227-3.665,6.6-4.291,8.947-4.627a20.252,20.252,0,0,1,8.559.755,26.7,26.7,0,0,1,10.159,4.533,19.564,19.564,0,0,1,3.135,3.017c.159.192.309.375.451.563a22.375,22.375,0,0,1,3.607,7.316,28.637,28.637,0,0,1,1.239,10.308,45.364,45.364,0,0,1-.686,5.683,43.329,43.329,0,0,1-1.414,5.761l.623-.135a87.345,87.345,0,0,0,2.962,10.45c1.613,4.593,3.572,8.585,7.353,15.794,4.06,7.74,9.561,16.917,12.48,21.7l1.128,1.832c3.246,5.257,5.205,8.431,6.784,13.665a46.978,46.978,0,0,1,1.932,10.929l0,2.493-.031.2a23.821,23.821,0,0,1-2.014,6.719,18.538,18.538,0,0,1-13.583,10.669c-5.209.955-9.883-.478-12.676-1.334a32.038,32.038,0,0,1-14.579-9.638c-1.27-1.429-2.216-2.693-2.907-3.617a40.884,40.884,0,0,1-5.344-9.31,35.578,35.578,0,0,1-2.4-9.416,23.253,23.253,0,0,1,.03-5.039c.492-4.484,2.039-9.856,4.729-18.964.383-1.3.747-2.533,1.1-3.707a189.748,189.748,0,0,1,6.5-19.072c1.2-2.935,2.247-5.3,3.092-7.206l.1-.231a73.6,73.6,0,0,0,2.918-7.214,41.33,41.33,0,0,0,1.4-5.648,43.556,43.556,0,0,0,.659-5.452,26.813,26.813,0,0,0-1.155-9.652,20.466,20.466,0,0,0-3.314-6.751c-.133-.174-.267-.338-.407-.507a17.775,17.775,0,0,0-2.837-2.73,25.088,25.088,0,0,0-9.492-4.207,18.686,18.686,0,0,0-7.833-.715c-2.191.313-5.857.838-7.638,3.768a7.082,7.082,0,0,0-.748,5.244c.226.754.624,1.579,3.213,4a39.613,39.613,0,0,0,4.493,3.669c.318.228.6.431.862.63a7.529,7.529,0,0,1,1.941,2.077,10.266,10.266,0,0,1,1.527,5.176c.056,1.025.022,2.056-.016,3.148l0,.086a25.392,25.392,0,0,1-1.7,8.235c-.479,1.269-.995,2.357-1.342,3.066a57.7,57.7,0,0,1-7.931,11.964c-1.1,1.36-2.231,2.767-3.393,4.354-4.022,5.482-6.03,9.88-9.356,17.167a132.673,132.673,0,0,0-5.256,13.381,125.916,125.916,0,0,0-4.344,16.769c-1.992,10.745-2.992,16.137-1.987,23.77a50.807,50.807,0,0,0,1.195,6.147c3.192,12.344,10.278,20.769,13.3,24.367a70.468,70.468,0,0,0,28.092,19.9l.264.1c.445.172.949.367,1.5.57a65.314,65.314,0,0,0,32.121,3.687,66.091,66.091,0,0,0,25.7-9.565l.244-.148c.317-.193.622-.378.916-.559a83.858,83.858,0,0,0,27.815-28.184l1.581.965a85.685,85.685,0,0,1-28.426,28.8q-.443.274-.926.565l-.243.147a67.853,67.853,0,0,1-26.4,9.816A64.83,64.83,0,0,1,1148.777,612.909Zm-11.969-145.493c-.647,1.7-1.394,3.389-2.276,5.375l-.1.232c-.839,1.891-1.884,4.245-3.068,7.152a187.924,187.924,0,0,0-6.439,18.905c-.352,1.174-.715,2.4-1.1,3.7-2.662,9.008-4.191,14.316-4.665,18.641a21.523,21.523,0,0,0-.031,4.636,33.727,33.727,0,0,0,2.277,8.924,39.082,39.082,0,0,0,5.11,8.9c.672.9,1.59,2.126,2.809,3.5a30.209,30.209,0,0,0,13.738,9.1c2.63.807,7.033,2.158,11.8,1.283a16.686,16.686,0,0,0,12.242-9.64,21.955,21.955,0,0,0,1.856-6.2l.011-.075v-2.294a45.118,45.118,0,0,0-1.855-10.445c-1.509-5-3.42-8.1-6.587-13.229l-1.133-1.839c-2.93-4.8-8.454-14.016-12.538-21.8-3.825-7.292-5.81-11.338-7.46-16.041A89.482,89.482,0,0,1,1136.807,467.416Z",
    transform: "translate(-1078.861 -427.148)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(120.311 29.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M1372.761,319.305l.659-.651-.671.638c-.056-.056-.112-.113-.168-.176a109.088,109.088,0,0,0-13.3-11.688l-.156-.112c-.845-.618-1.716-1.25-2.617-1.875-1.848-1.28-5.29-3.664-9.611-6.1a90.727,90.727,0,0,0-26.815-10.033,92.11,92.11,0,0,0-33.592-.311,77.444,77.444,0,0,0-9.165,2.414c-.932.292-1.911.618-2.912.973l-.617-1.746c1.023-.361,2.022-.695,2.97-.992a77.3,77.3,0,0,1,9.408-2.473,93.935,93.935,0,0,1,34.273.319,92.606,92.606,0,0,1,27.362,10.236c4.395,2.479,7.881,4.894,9.755,6.192.841.583,1.652,1.17,2.411,1.724h0l.252.182a110.823,110.823,0,0,1,13.7,12.025c.065.072.1.1.133.139Z",
    transform: "translate(-1273.794 -285.757)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(55.191 63.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M1168.327,403.015a137.163,137.163,0,0,1,.951-19.935c.782-6.413,1.3-10.65,3.2-16.257a68.753,68.753,0,0,1,8.826-17.14,95.635,95.635,0,0,1,7.015-8.925c.255-.286.513-.569.777-.852l1.354,1.264c-.254.272-.5.545-.751.824a93.776,93.776,0,0,0-6.863,8.73,67.065,67.065,0,0,0-8.6,16.694c-1.837,5.426-2.344,9.588-3.111,15.887a168.585,168.585,0,0,0-.855,21.964Z",
    transform: "translate(-1168.285 -339.906)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(244.658 35.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M1508.625,369.332l-1.434-1.17c.114-.139.234-.285.366-.443a24.374,24.374,0,0,0,4.8-9.89,22.922,22.922,0,0,0,.415-2.478,30.368,30.368,0,0,0-1.356-11.737,43.283,43.283,0,0,0-5.407-12.046c-.571-.939-1.174-1.865-1.846-2.829a61.783,61.783,0,0,0-10.1-11.289c-1.337-1.157-2.525-2.08-3.674-2.972a45.2,45.2,0,0,1-5.565-4.863c-.554-.585-1.11-1.216-1.7-1.927a59.353,59.353,0,0,1-4.215-5.855,54.852,54.852,0,0,1-3.376-6.263c-.091-.194-.179-.39-.268-.586l1.689-.76c.084.186.168.373.259.567a53.169,53.169,0,0,0,3.268,6.061,57.421,57.421,0,0,0,4.07,5.655c.564.679,1.094,1.28,1.62,1.836a43.063,43.063,0,0,0,5.356,4.674c1.168.907,2.376,1.845,3.748,3.033a63.623,63.623,0,0,1,10.413,11.633c.693,1,1.316,1.952,1.906,2.923a44.889,44.889,0,0,1,5.615,12.531,32.364,32.364,0,0,1,1.407,12.419,24.776,24.776,0,0,1-.448,2.679,26.22,26.22,0,0,1-5.179,10.658C1508.849,369.061,1508.734,369.2,1508.625,369.332Z",
    transform: "translate(-1475.267 -294.224)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(241.724 14.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M1477.312,284.2a11.832,11.832,0,0,1-3.052-1.876,10.738,10.738,0,0,1-1.929-2.172c-2.818-4.207-1.673-8.91-1.05-10.737a11.705,11.705,0,0,1,3.77-5.7,9.324,9.324,0,0,1,1.042-.728,11.716,11.716,0,0,1,2.558-1.188,8.246,8.246,0,0,1,4.837-.118,8.619,8.619,0,0,1,4.936,3.843,9.9,9.9,0,0,1,1.293,3.277,12.062,12.062,0,0,1,.181,3.1,5.56,5.56,0,0,1-2.447,4.544,4.9,4.9,0,0,1-2.205.688,7.339,7.339,0,0,1-3.192-.513l.682-1.721a5.514,5.514,0,0,0,2.365.389,3.059,3.059,0,0,0,1.388-.425,3.757,3.757,0,0,0,1.563-3.112,10.159,10.159,0,0,0-.153-2.593,8.037,8.037,0,0,0-1.052-2.656,6.733,6.733,0,0,0-3.866-3.034,6.425,6.425,0,0,0-3.773.1,9.681,9.681,0,0,0-2.119.984,7.551,7.551,0,0,0-.884.613,9.969,9.969,0,0,0-3.171,4.847c-.538,1.574-1.525,5.6.834,9.118a8.867,8.867,0,0,0,1.594,1.795,9.953,9.953,0,0,0,2.572,1.578Z",
    transform: "translate(-1470.514 -261.37)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(248.519 5.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M1486.994,279.347a13.012,13.012,0,0,1-3.462-.463,14.8,14.8,0,0,1-2.008-.683l.729-1.7a12.72,12.72,0,0,0,1.745.593c4.52,1.243,8.493-.672,10.463-1.923a14.537,14.537,0,0,0,5.532-6.62,19.3,19.3,0,0,0,1.208-3.83,16.764,16.764,0,0,0-1.084-11.016,15.735,15.735,0,0,0-5.83-6.469l1.011-1.55a17.527,17.527,0,0,1,6.488,7.22,18.591,18.591,0,0,1,1.224,12.208,20.991,20.991,0,0,1-1.322,4.179,16.348,16.348,0,0,1-6.232,7.438A15.836,15.836,0,0,1,1486.994,279.347Z",
    transform: "translate(-1481.523 -245.684)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(217.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M1436.77,288.022l-.03-.057c-.031-.059-.061-.119-.088-.179a43.12,43.12,0,0,1-4.752-15.8,39.341,39.341,0,0,1-.106-6.512c.084-1.284.2-2.806.478-4.531a28.933,28.933,0,0,1,3.149-9.342,26.455,26.455,0,0,1,9.36-10.218,25.939,25.939,0,0,1,12.6-3.873c.485-.025.909-.044,1.271-.051a29.279,29.279,0,0,1,12.419,2.394,35.279,35.279,0,0,1,5.155,2.669l-1.01,1.552a33.279,33.279,0,0,0-4.893-2.528,27.434,27.434,0,0,0-11.629-2.235c-.352.006-.755.024-1.211.048a24.132,24.132,0,0,0-11.718,3.6,24.682,24.682,0,0,0-8.712,9.531,27.108,27.108,0,0,0-2.948,8.755c-.267,1.644-.377,3.114-.458,4.362a37.386,37.386,0,0,0,.1,6.207,41.313,41.313,0,0,0,4.565,15.148l.119.238Z",
    transform: "translate(-1431.708 -237.453)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(193.552 36.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M1424.6,324.261l-1.735-.647,3.171-8.479-18.508-17.081-14.431,5.239-.632-1.741,15.489-5.624,20.251,18.691Z",
    transform: "translate(-1392.463 -295.928)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(205.527 41.644)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 11.7,
    height: 1.852,
    transform: "matrix(0.702, -0.712, 0.712, 0.702, 0, 8.332)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(59.542 119.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M1184.45,464.651c-5.112,0-9.116-7.258-9.116-16.522s4-16.528,9.116-16.528c3.564,0,6.716,3.57,8.227,9.318a28.21,28.21,0,0,1,.9,7.211C1193.572,457.393,1189.565,464.651,1184.45,464.651Zm0-31.2c-3.937,0-7.264,6.721-7.264,14.677s3.327,14.671,7.264,14.671,7.271-6.718,7.271-14.671a26.337,26.337,0,0,0-.834-6.737v0C1189.619,436.567,1187.093,433.452,1184.45,433.452Z",
    transform: "translate(-1175.334 -431.6)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(68.41 117.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M1202.314,464.605a6.6,6.6,0,0,1-.926-.065l-11.565-1.6.255-1.834,11.567,1.6a4.684,4.684,0,0,0,3.759-1.115c2.413-2.137,5.291-6.408,5.291-14.619a23.817,23.817,0,0,0-2.349-10.584,21.406,21.406,0,0,0-4.455-6.089,4.76,4.76,0,0,0-4.533-1.135l-9.157,2.548-.5-1.784,9.159-2.549a6.627,6.627,0,0,1,6.306,1.579,23.264,23.264,0,0,1,4.839,6.613,25.658,25.658,0,0,1,2.538,11.4c0,8.9-3.217,13.616-5.916,16.005A6.508,6.508,0,0,1,1202.314,464.605Z",
    transform: "translate(-1189.702 -427.143)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(75.731 125.023)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 12.388,
    height: 1.851,
    transform: "translate(0 3.468) rotate(-16.258)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(107.316 86.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M1267.252,471.5a8.833,8.833,0,0,1-3.061-.552,8.68,8.68,0,0,1-5.024-4.767c-3.659-8.537-9.156-25.635-4.859-44.227,5.831-25.207,27.657-37.414,31.973-39.6a8.125,8.125,0,0,1,1.074-.462c2.591-.906,11.578-3.851,18.6-3.693h.006c.263,0,.541.012.818.025l-.086,1.85c-.251-.012-.5-.024-.76-.024-6.728-.154-15.455,2.71-17.969,3.59a6.418,6.418,0,0,0-.841.361c-4.2,2.13-25.37,13.97-31.015,38.375-4.178,18.079,1.188,34.751,4.757,43.08a6.943,6.943,0,0,0,9.465,3.466l30.639-15.127.818,1.66-30.637,15.127A8.785,8.785,0,0,1,1267.252,471.5Z",
    transform: "translate(-1252.739 -378.191)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(144.974 61.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M1382.164,473.628a68.675,68.675,0,0,1-59.1-33.948,67.188,67.188,0,0,1-4.017-8.033,68.429,68.429,0,0,1,63.117-94.837c2.2,0,4.384.1,6.489.307,1.821.169,3.645.415,5.42.733a67.8,67.8,0,0,1,11.665,3.128l-.636,1.739a66.05,66.05,0,0,0-11.351-3.043c-1.728-.309-3.5-.549-5.271-.713-2.049-.2-4.173-.3-6.314-.3a66.592,66.592,0,0,0-61.408,92.27,65.226,65.226,0,0,0,3.907,7.814,66.817,66.817,0,0,0,57.5,33.032,66.59,66.59,0,0,0,52.672-25.865c.553-.711,1.118-1.475,1.729-2.339a66.12,66.12,0,0,0,12.155-38.354,67.281,67.281,0,0,0-.621-9.1,66.241,66.241,0,0,0-8.43-24.426,66.76,66.76,0,0,0-34.569-28.971l.638-1.738a68.609,68.609,0,0,1,35.531,29.774,68.115,68.115,0,0,1,8.665,25.11,69.044,69.044,0,0,1,.638,9.351,67.965,67.965,0,0,1-12.495,39.423c-.628.888-1.21,1.674-1.778,2.4a68.443,68.443,0,0,1-54.135,26.582Z",
    transform: "translate(-1313.754 -336.81)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(159.724 76.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M1391.313,468.029a53.329,53.329,0,0,1-37.927-15.7,53.886,53.886,0,0,1-4.987-5.747l1.482-1.111a51.784,51.784,0,1,0,33.022-82.24,51.83,51.83,0,0,0-33.029,82.24l-1.48,1.113A53.666,53.666,0,0,1,1382.6,361.4a53.669,53.669,0,1,1,8.711,106.626Z",
    transform: "translate(-1337.654 -360.7)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(175.75 76.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M1364.341,453.09l-.721-1.706c.362-.152,36.376-15.454,56.6-30.921a11.984,11.984,0,0,0,3.527-14.542c-4.651-9.885-14.947-28.528-31.648-42.321l1.179-1.428c16.979,14.024,27.427,32.936,32.145,42.961a13.845,13.845,0,0,1-4.078,16.8C1400.933,437.545,1364.7,452.937,1364.341,453.09Z",
    transform: "translate(-1363.62 -362.173)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(170.902 79.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M1356.073,449.377l0-.935-.3-.863a203.323,203.323,0,0,0,51.8-28.665,8.118,8.118,0,0,0,2-10.57c-6.616-11.184-19.487-31.226-31.37-39.808l1.083-1.5c12.157,8.779,25.192,29.058,31.88,40.366a9.97,9.97,0,0,1-2.46,12.98,205.356,205.356,0,0,1-52.29,28.938l-.15.052Z",
    transform: "translate(-1355.765 -367.034)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(114.035 93.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M1272.843,466.294a5.467,5.467,0,0,1-1.871-.33,5.524,5.524,0,0,1-3.2-3.072,53.4,53.4,0,0,1-2.722-32.594c5.276-21.5,11.764-28.018,25.25-35.323a57.153,57.153,0,0,1,14.717-5.412l.442,1.8a55.435,55.435,0,0,0-14.277,5.241c-13.581,7.356-19.3,13.619-24.334,34.135a51.532,51.532,0,0,0,2.635,31.446,3.624,3.624,0,0,0,2.127,2.04,3.572,3.572,0,0,0,2.9-.188l25.774-13.374.852,1.644-25.774,13.375A5.469,5.469,0,0,1,1272.843,466.294Z",
    transform: "translate(-1263.626 -389.563)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(181.27 103.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M1372.625,411.318l4.246,25.336a4.523,4.523,0,0,0,6.234,3.413l10.122-4.32a4.525,4.525,0,0,0,2.1-6.487L1382.2,407.386a4.51,4.51,0,0,0-6.45-1.389l-1.247.864A4.519,4.519,0,0,0,1372.625,411.318Z",
    transform: "translate(-1372.563 -405.188)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(125.068 141.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1281.608,474.53a1.816,1.816,0,0,0,2.531,1.012l10.239-5.221a1.807,1.807,0,0,0,.617-2.716l-.154-.2a1.8,1.8,0,0,0-2.3-.494l-10.085,5.413A1.809,1.809,0,0,0,1281.608,474.53Z",
    transform: "translate(-1281.502 -466.695)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(253.907 170.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1513.669,537.334l-9.089-3.878-14.327-6.116.729-1.7,23.05,9.838a6,6,0,0,0,3.578-1.4,5.916,5.916,0,0,0,1.042-1.186,5.611,5.611,0,0,0,.949-2.481,5.67,5.67,0,0,0-.107-2.035l-16.939-13.6,1.158-1.444,17.4,13.971.082.278a7.512,7.512,0,0,1,.24,3.057,7.4,7.4,0,0,1-1.25,3.284,7.663,7.663,0,0,1-1.371,1.558,7.779,7.779,0,0,1-4.952,1.854Z",
    transform: "translate(-1490.254 -513.33)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(112.532 54.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M1262.318,352.718l-1.127-1.469,20.853-15.99-7.927-8.215,1.332-1.286,8.507,8.817a1.106,1.106,0,0,1-.121,1.644Z",
    transform: "translate(-1261.191 -325.758)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(118.961 30.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1286.528,320.96l-7.615-26.641-7.305-5.355,1.094-1.493,7.816,5.729,7.79,27.251Z",
    transform: "translate(-1271.607 -287.471)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(75.284 52.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M1238.687,351.65a1.015,1.015,0,0,1-.383-.075l-37.463-15.251,2.548-13.875,1.821.335-2.279,12.392,34.543,14.062-2.974-11.9,1.8-.449,3.374,13.5a1.017,1.017,0,0,1-.984,1.261Z",
    transform: "translate(-1200.84 -322.449)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(77.382 30.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M1236.807,324.646l-32.568-15.182.586-.894c.125-.19,12.769-19,41.462-21.424l.761-.065,7,24.88Zm-29.793-15.931,29.579,13.789,15.323-11.275-6.234-22.17C1221.96,291.329,1209.822,305.1,1207.014,308.715Z",
    transform: "translate(-1204.239 -287.081)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(32.61 122.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M1133.545,450.32l-1.848-.109c.018-.315.512-7.748,5.984-12.091,3.38-2.684,7.875-3.564,13.36-2.617l-.315,1.824c-4.936-.85-8.934-.1-11.883,2.234C1134.021,443.38,1133.549,450.251,1133.545,450.32Z",
    transform: "translate(-1131.697 -435.135)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(36.053 139.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M1160.642,468.394c-12.972-7.352-21.827-.388-22.2-.087l-1.17-1.436c.1-.081,10.171-8.085,24.279-.088Z",
    transform: "translate(-1137.275 -463.234)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(34.73 153.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M1154.406,495.8c-8.487-10.226-18.351-7.6-18.767-7.483l-.507-1.781c.461-.132,11.415-3.1,20.7,8.082Z",
    transform: "translate(-1135.132 -486.081)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(22.433 173.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1137.067,533.8c-4.428-13.892-21.686-14.142-21.86-14.143l.008-1.852c.186,0,18.776.246,23.615,15.432l.045.137v.144l-.936,0Z",
    transform: "translate(-1115.207 -517.81)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(7.139 200.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M1122.051,573.642l-.065-.064c-15.673-16.994-29.858-6.813-30.453-6.371l-1.106-1.485c.159-.119,16.09-11.651,32.921,6.6l-.645.595Z",
    transform: "translate(-1090.427 -562.019)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(1.642 224.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M1083.314,628.766l-1.794-.462a39.671,39.671,0,0,1,7.8-14.265c5.425-6.416,15.438-13.917,32.289-13.141l-.083,1.849c-12.911-.583-23.245,3.6-30.743,12.43A38.551,38.551,0,0,0,1083.314,628.766Z",
    transform: "translate(-1081.521 -600.842)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(37.862 237.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M1147.827,682.681a62.775,62.775,0,0,1-6.812-19.818c-1.8-10.655-1.465-26.393,10.385-40.873l1.433,1.173c-21.852,26.7-3.6,58.258-3.412,58.574Z",
    transform: "translate(-1140.207 -621.99)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(74.528 248.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M1229.774,684.016c-19.342-4.4-26.319-16.178-28.766-25.283a42.951,42.951,0,0,1-.655-18.824l1.806.408a41.862,41.862,0,0,0,.655,18c3.382,12.492,12.591,20.53,27.371,23.892Z",
    transform: "translate(-1199.614 -639.909)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(88.507 238.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M1267.942,648.572c-19.367-.259-30.732-6.846-36.858-12.326-6.691-5.985-8.736-11.867-8.82-12.114l1.753-.594-.877.3.877-.3c.02.057,2.016,5.742,8.387,11.406,5.889,5.234,16.836,11.527,35.545,11.778Z",
    transform: "translate(-1222.264 -623.536)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(199.2 239.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M1401.614,625.916v-.006h1.852Z",
    transform: "translate(-1401.614 -625.91)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(213.225 292.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M1425.16,712.921l-.822-1.659.208-.1.828,1.656Z",
    transform: "translate(-1424.338 -711.158)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(261.321 233.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M1523.727,622.56c-9.455-7.032-17.578-4.087-19.61-3.156v.352l-.926.006,0-.926h-.923v-.545l.476-.27c.421-.234,10.432-5.62,22.092,3.054Z",
    transform: "translate(-1502.265 -616.156)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(254.032 215.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M1490.831,603.857c-.032-.125-3.141-12.541,9.13-16.473l.138-.044h.144l0,.935.28.873c-10.585,3.391-8.019,13.8-7.9,14.24Z",
    transform: "translate(-1490.456 -587.34)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(114.788 344.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M1278.071,800.955c-8.267,0-12.974-3.145-13.225-3.316l1.047-1.527-.524.764.522-.765c.073.05,7.448,4.926,19.837,2.1l.412,1.806A36.278,36.278,0,0,1,1278.071,800.955Z",
    transform: "translate(-1264.846 -796.11)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(113.182 324.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M1284.278,774.774c-17.877,0-21.813-10.706-21.983-11.2l-.051-.148v-.156l.935,0,.865-.3c.168.472,4.378,11.627,24.7,9.739l.086,0,0,.96.083.888C1287.276,774.7,1285.731,774.774,1284.278,774.774Z",
    transform: "translate(-1262.244 -762.968)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(120.427 301.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M1303.377,742.4c-19.512,0-26.9-10.824-28.8-14.377a12.508,12.508,0,0,1-.6-1.267l1.73-.659a10.723,10.723,0,0,0,.5,1.057c1.917,3.6,9.911,15.183,32.216,13.157l.167,1.844C1306.769,742.32,1305.03,742.4,1303.377,742.4Z",
    transform: "translate(-1273.982 -726.095)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(132.759 276.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M1331.6,707.661a42.343,42.343,0,0,1-37.534-21.321l-.1-.2v-.223l.932,0,.819-.417c.472.928,11.874,22.668,40.518,20.1l.165,1.845C1334.746,707.591,1333.144,707.661,1331.6,707.661Z",
    transform: "translate(-1293.964 -685.499)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(247.165 315.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M1487.988,761.284c-8.934-4.18-8.671-11.547-8.654-11.859l1.85.046c-.013.307-.2,6.493,7.589,10.135Z",
    transform: "translate(-1479.33 -749.425)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(253.834 307.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M1511.634,745.324a33.074,33.074,0,0,1-21.5-7.869l1.27-1.347a31.867,31.867,0,0,0,21.606,7.334l.08,1.85C1512.6,745.313,1512.112,745.324,1511.634,745.324Z",
    transform: "translate(-1490.135 -736.108)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(257.028 290.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M1511.555,715.672a73.526,73.526,0,0,1-16.245-1.879l.45-1.8c.231.057,23.1,5.631,35.794-3.25v-.45l.932-.006v.926l.92.006v.469l-.378.277C1526.945,714.437,1518.753,715.672,1511.555,715.672Z",
    transform: "translate(-1495.31 -708.29)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(257.25 260.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1495.8,679.2l-.13-1.847c.238-.017,23.855-1.863,38.071-18.044v-.037l.271-.278.66.655h.92V660l-.225.267C1520.664,677.277,1496.045,679.187,1495.8,679.2Z",
    transform: "translate(-1495.669 -658.999)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(282.962 189.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M1547.651,553.817a8.269,8.269,0,0,0-2.931-5.808c-2.952-2.327-7.122-1.854-7.164-1.848l-.227-1.838c.2-.024,4.955-.58,8.524,2.221a10.04,10.04,0,0,1,3.638,7.059Z",
    transform: "translate(-1537.329 -544.263)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(281.416 176.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M1534.834,530.462a6.331,6.331,0,0,1,1.547-4.391c1.439-1.646,3.714-2.554,6.762-2.7l.088,1.85c-2.509.119-4.338.807-5.435,2.044a4.441,4.441,0,0,0-1.117,3.043Z",
    transform: "translate(-1534.825 -523.372)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(266.194 196.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M1516.375,560.07a8.874,8.874,0,0,1-6.214-2.263l1.263-1.354c3.388,3.162,8.9,1.082,8.958,1.061l.672,1.726A14.052,14.052,0,0,1,1516.375,560.07Z",
    transform: "translate(-1510.161 -556.453)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(272.916 201.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M1521.488,579.416c-2.373-9.709,5.75-15.694,5.833-15.753l1.084,1.5c-.3.213-7.19,5.334-5.118,13.811l.026.22-.939,0Z",
    transform: "translate(-1521.053 -563.663)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(289.942 201.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M1561.646,577.958l-.23-.1-.015.06c-10.306-2.686-12.666-13-12.762-13.437l1.808-.4c.021.1,2.232,9.647,11.42,12.041l.244.063.178.178-.642.643Z",
    transform: "translate(-1548.639 -564.089)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(296.466 186.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M1580.252,546.2a19.031,19.031,0,0,0-20.222-3.309l-.821-1.66a20.979,20.979,0,0,1,22.265,3.578Z",
    transform: "translate(-1559.209 -539.498)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(290.219 163.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M1550.786,517.908l-1.7-.736c.081-.187,8.294-18.587,28.648-12.962l-.493,1.785C1558.462,500.806,1551.091,517.207,1550.786,517.908Z",
    transform: "translate(-1549.087 -503.142)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(279.73 138.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M1532.317,494.014c-.159-.954-3.582-23.451,23.157-32.653l.6,1.751c-25.274,8.7-22.082,29.708-21.934,30.6l.012.152-.944,0Z",
    transform: "translate(-1532.094 -461.361)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(271.342 93.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M1529.862,392.843a14.608,14.608,0,0,0-10.666-.514l-.694-1.716a16.316,16.316,0,0,1,12.133.548Z",
    transform: "translate(-1518.502 -389.7)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(257.095 68.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M1497.19,359.047l-1.771-.539c.033-.107,3.4-10.679,17.22-10.717l0,1.852C1500.229,349.676,1497.308,358.664,1497.19,359.047Z",
    transform: "translate(-1495.419 -347.79)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(235.713 48.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M1462.625,334.159l-1.851-.031c.022-.623.708-14.556,19.03-17.48l.292,1.829C1463.263,321.163,1462.643,333.631,1462.625,334.159Z",
    transform: "translate(-1460.774 -316.648)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(222.512 34.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M1441.223,309.883l-1.837-.229s.033-.281.136-.768c.565-2.7,4.335-16.107,23.19-14.669l-.141,1.846c-16.88-1.284-20.52,9.781-21.236,13.2C1441.255,309.641,1441.225,309.864,1441.223,309.883Z",
    transform: "translate(-1439.386 -294.11)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(218.652 18.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M1434.332,273.108l-1.2-1.409c.12-.1,12.162-10.145,25.26-.58l-1.092,1.5C1445.4,263.922,1434.779,272.729,1434.332,273.108Z",
    transform: "translate(-1433.131 -266.992)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(242.996 0.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M1480.634,253.678l-1.837-.231c1.212-9.673-4.919-13.481-6.16-14.147l-.062-.029.736-1.7s.058.025.176.083C1474.94,238.434,1482,242.8,1480.634,253.678Z",
    transform: "translate(-1472.575 -237.572)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(258.357 5.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M1498.439,260.858l-.976-1.573c5.663-3.515,2.9-11.519,2.569-12.42l.854-.331.658-.664.151.15.07.192C1502.156,247.269,1505.351,256.568,1498.439,260.858Z",
    transform: "translate(-1497.463 -245.87)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(247.759 28.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M1480.512,291.816c-.557-2.575-.331-7.314,4.05-8.741a3.535,3.535,0,0,1,2.006.122l-.65,1.734a1.893,1.893,0,0,0-.8-.089c-3.832,1.249-2.913,6.042-2.8,6.584l.021.2-.941,0Z",
    transform: "translate(-1480.292 -282.978)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(246.795 16.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M1489.248,277.58l-1.85-.044c.183-3.357-.582-5.977-2.27-7.843a10.159,10.159,0,0,0-6.4-3l.076-1.85a11.887,11.887,0,0,1,7.678,3.591C1488.528,270.68,1489.458,273.758,1489.248,277.58Z",
    transform: "translate(-1478.73 -264.841)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(259.252 24.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M1505.679,282.113a7.8,7.8,0,0,1-6.557-3.646l-.2-.183-.007-.422h.926l.63-.673.113.1.074.134a5.977,5.977,0,0,0,6.643,2.649l.4,1.807A9.32,9.32,0,0,1,1505.679,282.113Z",
    transform: "translate(-1498.914 -277.19)",
    fill: "#81afcc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(424.582 241.019)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 15.722,
    cy: 15.722,
    rx: 15.722,
    ry: 15.722,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(334.873 341.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 4.598,
    cy: 4.598,
    rx: 4.598,
    ry: 4.598,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(339.471 323.243)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 5.647,
    cy: 5.647,
    rx: 5.647,
    ry: 5.647,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(418.769 211.795)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 5.647,
    cy: 5.647,
    rx: 5.647,
    ry: 5.647,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(367.348 154.663)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 16.883,
    cy: 16.883,
    rx: 16.883,
    ry: 16.883,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(381.54 78.92)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 24.531,
    cy: 24.531,
    rx: 24.531,
    ry: 24.531,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(323.372 8.637)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 28.259,
    cy: 28.259,
    rx: 28.259,
    ry: 28.259,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(367.096 83.02)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 4.469,
    cy: 4.469,
    rx: 4.469,
    ry: 4.469,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(149.643 6.251)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 12.002,
    cy: 12.002,
    rx: 12.002,
    ry: 12.002,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(0 187.836)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 10.792,
    cy: 10.792,
    rx: 10.792,
    ry: 10.792,
    transform: "translate(0 0)",
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(4.17 220.69)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 6.352,
    cy: 6.352,
    rx: 6.352,
    ry: 6.352,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(331.398 332.391)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 2.052,
    cy: 2.052,
    rx: 2.052,
    ry: 2.052,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(306.805 375.383)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 76.504,
    cy: 9.797,
    rx: 76.504,
    ry: 9.797,
    fill: "#daefee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(43.303 54.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(4.573 29.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M1110.257,316.152c-3.164,0-5.549,1.85-5.549,4.3,0,2.427,2.359,4.258,5.489,4.258,3.215,0,5.549-1.791,5.549-4.258C1115.746,317.962,1113.438,316.152,1110.257,316.152Z",
    transform: "translate(-1104.708 -316.152)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M1108.349,268.855a22.542,22.542,0,0,0-9.9,2.114l-1.148.625,2.119,6.656,1.969-1.124a11.286,11.286,0,0,1,5.071-1.152c4.033.049,4.033,1.961,4.033,2.589,0,1.486-1.013,2.908-3.879,5.446-3.224,2.9-3.944,5.016-3.5,7.991l.259,2.485h8.448l-.146-2.675c-.162-2.049.73-3.736,3.079-5.823,3.252-2.9,5.739-5.394,5.739-8.944C1120.491,272.967,1116.737,268.855,1108.349,268.855Z",
    transform: "translate(-1097.299 -268.855)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(374.242 216.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M1646.3,696.553h-.025l0-1.852h.023a16.614,16.614,0,0,0,5.678-.965,13.912,13.912,0,0,0,8.667-9.2,22.583,22.583,0,0,0,.793-3.254,16.129,16.129,0,0,0,.5-4.525c-.094-1.105-.676-2.682-1.837-5.824l-.075-.2a13.633,13.633,0,0,1-.839-3.017,14.683,14.683,0,0,1-.086-3.119,14.24,14.24,0,0,1,.592-3.2c.38-1.2.773-1.777,2.427-4.211.368-.54.8-1.176,1.312-1.936a7.7,7.7,0,0,0,1.405-2.5,5.766,5.766,0,0,0-.18-3.159,5.51,5.51,0,0,0-1.437-2.224c-.547-.622-1.3-1.474-2.289-2.829a13.575,13.575,0,0,1-2.258-3.8,11.527,11.527,0,0,1-.479-4.526,17.048,17.048,0,0,1,1.114-4.82,17.546,17.546,0,0,1,1.729-3.723,4.493,4.493,0,0,0,.72-1.711c.548-2.655-.49-5.094-1.323-7.055a9.872,9.872,0,0,0-.869-1.639c-.392-.627-.928-1.487-1.939-3.461-1.616-3.156-1.965-4.315-2.068-5.46a12.127,12.127,0,0,1,.869-4.978,23.283,23.283,0,0,1,2.282-5.128,7.388,7.388,0,0,0,1.152-2.929c.347-2.148-.105-3.85-.927-6.942a10.85,10.85,0,0,0-1.876-4.261,5.527,5.527,0,0,0-.847-.753,3.579,3.579,0,0,1-1.182-1.336c-1.01-1.947-.469-3.984-.073-5.471a12.938,12.938,0,0,1,.933-2.422,10.819,10.819,0,0,1,1.852-2.666,9.1,9.1,0,0,0,.954-1.2,9.268,9.268,0,0,0,.982-6.606,10.371,10.371,0,0,0-1.45-3.18,11.594,11.594,0,0,0-.927-1.212c-.331-.393-.705-.838-1.219-1.555a29.253,29.253,0,0,1-1.757-2.819c-1-1.865-.838-3.609-.59-6.25.1-1.059.212-2.258.284-3.728,0-.059.268-5.932-1.281-10.027a4.57,4.57,0,0,0-1.559-2.093,1.67,1.67,0,0,0-.909-.382,1.543,1.543,0,0,0-1.031.567c-.319.388-.4,1.363-.229,2.9a15,15,0,0,0,.415,2.256c.11.443.223.9.325,1.51a9.06,9.06,0,0,1,.127,2.329,18.1,18.1,0,0,0,0,2.185c.072,1.3.222,2.323.355,3.225a13.255,13.255,0,0,1,.105,4.628,4.732,4.732,0,0,1-1.2,2.7,3.745,3.745,0,0,1-1.19.8,3.186,3.186,0,0,0-.865.544,4.381,4.381,0,0,0-1.074,1.548,7.683,7.683,0,0,0-.548,2.842,20.934,20.934,0,0,0,0,3.519l.021.3a7.346,7.346,0,0,0,.341,2.281,3.378,3.378,0,0,0,.655,1.005,5.287,5.287,0,0,1,.955,1.464,7.852,7.852,0,0,1,.462,4.418,9.52,9.52,0,0,1-.687,2.292,18.392,18.392,0,0,1-3.606,5.234,1.361,1.361,0,0,0-.475.672,6.029,6.029,0,0,0,.215,3.544,5.657,5.657,0,0,0,.291.819,14.807,14.807,0,0,1,.526,1.433c.562,1.757.843,2.638.7,3.438a3.522,3.522,0,0,1-1.706,2.266,14.221,14.221,0,0,0-1.773,1.528,10.865,10.865,0,0,0-2.3,3.2,9.537,9.537,0,0,0-.75,4.889,9.186,9.186,0,0,0,.786,3.089,10.443,10.443,0,0,0,.616,1.121,9.089,9.089,0,0,1,1,2.091,9.6,9.6,0,0,1,.477,2.4c.081,1.386-.237,2.247-1.181,4.8l-.1.259c-1.283,3.478-1.431,3.972-1.44,4.81a7.1,7.1,0,0,0,.415,2.5,3.676,3.676,0,0,0,.552,1.013,11.115,11.115,0,0,1,.772,1.231,10.415,10.415,0,0,1,1.491,4.965,7.255,7.255,0,0,1-.457,2.784,5.369,5.369,0,0,1-1.71,2.306,6.9,6.9,0,0,0-1.23,1.318,7.758,7.758,0,0,0-1.291,4.737,8.142,8.142,0,0,0,2.68,5.5,6.985,6.985,0,0,0,1.122.8,2.735,2.735,0,0,1,1.279,1.291c.414.932.253,2.081-.521,3.724a9.935,9.935,0,0,1-1.957,2.841,10.278,10.278,0,0,0-1.288,1.629c-.5.792-2.01,3.2-1.42,5.633a9.09,9.09,0,0,0,1.439,2.846c.215.315.426.589.657.89.381.5.814,1.063,1.4,1.963.93,1.424,1.165,2,1.09,2.659a3.4,3.4,0,0,1-1.837,2.319c-.232.158-.477.324-.717.513a9.5,9.5,0,0,0-2.719,4.059,12.671,12.671,0,0,0-.131,8.928c.463,1.313,1.547,4.386,4.452,5.954,1.827.987,3.624.989,5.7.992v.926l0,.926c-2.234,0-4.344-.005-6.582-1.213-3.534-1.909-4.784-5.454-5.318-6.968a14.577,14.577,0,0,1,.184-10.3,11.25,11.25,0,0,1,3.27-4.765c.273-.214.551-.4.815-.585.625-.426,1.009-.7,1.042-1a5.277,5.277,0,0,0-.8-1.439c-.551-.842-.96-1.378-1.323-1.85-.25-.328-.479-.628-.715-.971a10.842,10.842,0,0,1-1.711-3.456c-.513-2.116.042-4.489,1.652-7.054a12.079,12.079,0,0,1,1.494-1.9,8.159,8.159,0,0,0,1.643-2.375c.283-.6.725-1.685.5-2.185-.07-.157-.125-.2-.542-.454a8.751,8.751,0,0,1-1.391-1,9.687,9.687,0,0,1-1.683-12.69,8.753,8.753,0,0,1,1.522-1.644,3.585,3.585,0,0,0,1.21-1.587,5.451,5.451,0,0,0,.332-2.1,8.627,8.627,0,0,0-1.267-4.1,9.43,9.43,0,0,0-.657-1.047,5.479,5.479,0,0,1-.777-1.437,9.027,9.027,0,0,1-.53-3.169c.012-1.17.226-1.832,1.554-5.433l.1-.259c.93-2.521,1.126-3.088,1.07-4.054a7.8,7.8,0,0,0-.389-1.934,7.293,7.293,0,0,0-.822-1.705,12.372,12.372,0,0,1-.713-1.305,11.057,11.057,0,0,1-.948-3.687,11.368,11.368,0,0,1,.9-5.827,12.693,12.693,0,0,1,2.663-3.733,16.2,16.2,0,0,1,1.982-1.712c.762-.576.933-.736,1-1.115a9.009,9.009,0,0,0-.641-2.549,13.227,13.227,0,0,0-.47-1.278,7.51,7.51,0,0,1-.367-1.042,7.748,7.748,0,0,1-.179-4.649,3.113,3.113,0,0,1,.922-1.38A16.589,16.589,0,0,0,1645.5,575a7.706,7.706,0,0,0,.571-1.879,5.987,5.987,0,0,0-.325-3.382,3.527,3.527,0,0,0-.663-1,5.093,5.093,0,0,1-.958-1.489,8.585,8.585,0,0,1-.485-2.878l-.021-.3a22.823,22.823,0,0,1,0-3.809,9.313,9.313,0,0,1,.713-3.462,6.2,6.2,0,0,1,1.526-2.154,4.979,4.979,0,0,1,1.3-.831,1.99,1.99,0,0,0,.662-.425,2.924,2.924,0,0,0,.694-1.715,11.5,11.5,0,0,0-.113-4.042c-.138-.941-.3-2.007-.372-3.391a20.139,20.139,0,0,1,0-2.38,7.289,7.289,0,0,0-.1-1.928c-.091-.54-.191-.946-.3-1.376a16.673,16.673,0,0,1-.458-2.5c-.294-2.714.133-3.657.639-4.272a3.35,3.35,0,0,1,2.433-1.244h.039a3.449,3.449,0,0,1,1.968.721,6.439,6.439,0,0,1,2.223,2.951c1.687,4.459,1.411,10.516,1.4,10.772-.074,1.511-.189,2.732-.29,3.81-.24,2.55-.359,3.829.378,5.2a27.614,27.614,0,0,0,1.631,2.617c.471.659.822,1.075,1.131,1.442a13.414,13.414,0,0,1,1.057,1.386,12.216,12.216,0,0,1,1.7,3.754,11.052,11.052,0,0,1-1.222,8.049,10.7,10.7,0,0,1-1.133,1.436,9,9,0,0,0-1.575,2.259,11.317,11.317,0,0,0-.8,2.069c-.353,1.327-.753,2.832-.073,4.143a1.8,1.8,0,0,0,.657.712,7.448,7.448,0,0,1,1.094.979,12.319,12.319,0,0,1,2.3,5.036c.857,3.228,1.375,5.176.964,7.712a9.2,9.2,0,0,1-1.377,3.563,21.646,21.646,0,0,0-2.123,4.769c-.913,2.819-.827,3.779-.785,4.241.07.775.252,1.62,1.871,4.783.976,1.9,1.488,2.726,1.862,3.325a11.6,11.6,0,0,1,1,1.9c.885,2.081,2.1,4.932,1.433,8.152a6.3,6.3,0,0,1-.95,2.3,15.642,15.642,0,0,0-1.564,3.379,15.262,15.262,0,0,0-1.013,4.32,9.7,9.7,0,0,0,.387,3.825,11.828,11.828,0,0,0,2,3.291c.944,1.288,1.633,2.071,2.186,2.7a7.248,7.248,0,0,1,1.81,2.882,7.566,7.566,0,0,1,.215,4.17,9.1,9.1,0,0,1-1.668,3.092c-.514.763-.948,1.4-1.316,1.942-1.626,2.392-1.9,2.814-2.194,3.729a12.406,12.406,0,0,0-.51,2.786,12.688,12.688,0,0,0,.072,2.709,11.8,11.8,0,0,0,.742,2.641l.077.206c1.218,3.3,1.83,4.954,1.945,6.309a17.746,17.746,0,0,1-.524,5.015,24.425,24.425,0,0,1-.861,3.516,16.626,16.626,0,0,1-4.633,7.286,16.8,16.8,0,0,1-5.138,3.053A18.56,18.56,0,0,1,1646.3,696.553Z",
    transform: "translate(-1633.503 -530.542)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(392.803 253.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M1664.585,718.623q-.51,0-1.008,0l.015-1.852c3.555.026,8.008-.113,10.256-.265a37.709,37.709,0,0,0,6.672-.974c3.143-.764,3.854-1.395,4.123-1.632a6.923,6.923,0,0,0,2.164-4.418,10.038,10.038,0,0,0-.3-3.674,15.718,15.718,0,0,0-.435-1.566c-.2-.636-.45-1.426-.77-2.777a6.87,6.87,0,0,1-.272-3.059,4.68,4.68,0,0,1,1.6-2.927,3.021,3.021,0,0,1,1.668-.638,2.345,2.345,0,0,0,.978-.285,4.462,4.462,0,0,0,1.759-2.154,4.9,4.9,0,0,0,.546-2.525,5.8,5.8,0,0,0-1.993-3.523,6,6,0,0,0-1.832-1.314,3.426,3.426,0,0,1-1.669-1.44c-1.433-2.431-.089-5.618.418-6.818a8.484,8.484,0,0,1,1.478-2.4,3.552,3.552,0,0,0,.894-1.669c.346-1.352.178-2.594-.126-4.847a8.882,8.882,0,0,0-.586-2.427,3.888,3.888,0,0,0-.7-.939c-.279-.31-.66-.734-1.209-1.443a17.718,17.718,0,0,1-1.655-2.432,7.926,7.926,0,0,1-1.213-3.092,4.28,4.28,0,0,1,.887-2.845c.321-.543.718-1.22,1.2-2.213a16.78,16.78,0,0,0,1.553-4.244,13.1,13.1,0,0,0,.247-3.282,13.991,13.991,0,0,0-.947-4.1,11.565,11.565,0,0,0-.551-1.313c-.2-.429-.481-1.017-.955-2.164a17.857,17.857,0,0,1-1.213-3.4,10.113,10.113,0,0,1,.6-4.824,19.206,19.206,0,0,1,1.191-3.108,24.266,24.266,0,0,0,1.283-3.27c.652-2.049.682-2.806.511-3.486a5.514,5.514,0,0,0-1.314-2.286,4.568,4.568,0,0,0-1.192-.967,3.276,3.276,0,0,1-1.21-1.1c-.7-1.1-.485-2.144-.207-3.467.107-.511.229-1.089.333-1.79.11-.742.1-2.8.095-6.533-.006-2.363-.052-3.028-.082-3.467a13.9,13.9,0,0,1-.023-1.6l.013-.5a8.524,8.524,0,0,0-.376-3.519c-.494-1.333-.8-1.526-.883-1.554-.012.009-.244.086-.727.839s-.591,1.525-.642,3.412c-.046,1.754-.023,3.091,0,4.272l0,.259c.044,2.65.063,3.859-.006,4.434a14.934,14.934,0,0,1-1.627,5.422,11.982,11.982,0,0,1-1.159,1.765,2.4,2.4,0,0,0-.634,1.254c-.127.795.12,1.5.741,3.151a16.944,16.944,0,0,0,1.123,2.416,8.006,8.006,0,0,1,1.021,2.677,2.687,2.687,0,0,1,.033.421c.017.319.053,1.008.139,2.534l.007.13a24.33,24.33,0,0,1,.042,4.111,6.273,6.273,0,0,1-.645,2.737c-.49.845-1.06,1.212-2.585,2.192l-.185.119c-1.324.852-2.474,1.592-2.729,1.81-.846,1.194-.673,2.977-.58,3.94a8.753,8.753,0,0,0,.285,1.521l-1.783.5a10.653,10.653,0,0,1-.345-1.842c-.11-1.135-.338-3.5.964-5.261.229-.311.654-.6,3.186-2.225l.185-.119c1.419-.911,1.728-1.12,1.984-1.562a4.8,4.8,0,0,0,.4-1.984,22.691,22.691,0,0,0-.048-3.832l-.007-.13c-.085-1.53-.122-2.221-.139-2.54l-.012-.219a6.242,6.242,0,0,0-.818-2.089,18.925,18.925,0,0,1-1.231-2.652c-.652-1.736-1.046-2.784-.835-4.1a4.181,4.181,0,0,1,.992-2.086,10.144,10.144,0,0,0,1-1.515,13.182,13.182,0,0,0,1.419-4.769c.055-.448.032-1.853-.007-4.18l0-.258c-.019-1.139-.042-2.557,0-4.352.05-1.885.138-3.12.934-4.362.309-.481,1.126-1.774,2.409-1.686,1.507.091,2.2,1.958,2.495,2.756a10.207,10.207,0,0,1,.491,4.217l-.013.488a12.138,12.138,0,0,0,.019,1.428c.032.464.08,1.165.086,3.59.011,4.072.016,5.931-.115,6.809-.112.756-.245,1.391-.353,1.9-.26,1.235-.328,1.647-.046,2.087a1.51,1.51,0,0,0,.608.511,6.361,6.361,0,0,1,1.612,1.313,7.312,7.312,0,0,1,1.732,3.071c.294,1.167.158,2.3-.541,4.5a26.194,26.194,0,0,1-1.369,3.488,17.472,17.472,0,0,0-1.093,2.846,8.378,8.378,0,0,0-.554,4,17.993,17.993,0,0,0,1.1,3c.456,1.1.712,1.644.917,2.078a13.736,13.736,0,0,1,.623,1.484,15.81,15.81,0,0,1,1.05,4.615,15.044,15.044,0,0,1-.279,3.757,18.558,18.558,0,0,1-1.7,4.684c-.512,1.061-.949,1.8-1.269,2.348-.559.95-.689,1.2-.639,1.735a6.557,6.557,0,0,0,.992,2.371,15.934,15.934,0,0,0,1.5,2.191c.507.656.847,1.034,1.121,1.337a5.636,5.636,0,0,1,.964,1.323,8.982,8.982,0,0,1,.779,3.035c.324,2.4.52,3.851.085,5.553a5.343,5.343,0,0,1-1.265,2.395,6.731,6.731,0,0,0-1.2,1.938c-.407.966-1.488,3.529-.528,5.158a1.668,1.668,0,0,0,.9.722,7.789,7.789,0,0,1,2.324,1.67,7.569,7.569,0,0,1,2.523,4.672,6.682,6.682,0,0,1-.714,3.462,6.177,6.177,0,0,1-2.549,3,4.165,4.165,0,0,1-1.638.5,1.249,1.249,0,0,0-.759.262,2.91,2.91,0,0,0-.917,1.8,5.205,5.205,0,0,0,.253,2.3c.3,1.283.532,2.006.733,2.645a17.567,17.567,0,0,1,.478,1.731,11.884,11.884,0,0,1,.328,4.311,8.735,8.735,0,0,1-2.772,5.56c-.654.579-1.75,1.275-4.912,2.045a39.4,39.4,0,0,1-6.984,1.022C1671.922,718.489,1668.078,718.623,1664.585,718.623Z",
    transform: "translate(-1663.577 -590.644)",
    fill: "#81afcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(356.047 245.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M1625.09,715.395c-.647,0-1.119-.013-2.216-.045l-2.8-.077c-1.549-.041-2.483-.065-3.894-.142-2.669-.149-3.177-.281-3.7-.482-.315-.121-1.277-.491-3.427-2.685-2.131-2.174-3.3-3.372-3.8-5.182a10.23,10.23,0,0,1-.134-3.952,8.6,8.6,0,0,1,1.091-4.255,4.427,4.427,0,0,1,1.345-1.345,8.787,8.787,0,0,0,1.636-1.454,6.087,6.087,0,0,0,1.446-2.066,3.5,3.5,0,0,0,.2-2.318c-.17-.5-.472-.79-1.319-1.553a11.876,11.876,0,0,0-1.975-1.445,7.326,7.326,0,0,1-2.115-1.757,5.6,5.6,0,0,1-1.285-2.308c-.4-1.611.19-2.893,1.16-5.017a11.984,11.984,0,0,1,2.676-4.228,7.578,7.578,0,0,1,1.261-.968,1.587,1.587,0,0,0,.641-.588,4.677,4.677,0,0,0,.294-3.369,11.119,11.119,0,0,0-1.326-3.053c-.531-1-.936-1.63-1.26-2.14a7.168,7.168,0,0,1-1.133-2.435,10.891,10.891,0,0,1-.237-3.021,10.293,10.293,0,0,1,.762-4.3,8.858,8.858,0,0,1,1.587-2.407,7.288,7.288,0,0,1,1.384-1.165,3.1,3.1,0,0,0,.823-.72,7.427,7.427,0,0,0,.825-2.317c.52-2.25.757-3.276.567-4.419a8.54,8.54,0,0,0-2-4.014c-.264-.309-.519-.562-.766-.807a4.643,4.643,0,0,1-1.536-2.43,14.5,14.5,0,0,1-.126-2.15,18.581,18.581,0,0,1,.006-2.532,6.3,6.3,0,0,1,1.183-3.176,3.474,3.474,0,0,1,1.968-1.286,2.044,2.044,0,0,0,.994-.532c.892-.907.864-2.444.838-3.8a8.4,8.4,0,0,0-.754-3.512,5.958,5.958,0,0,0-1.55-2.046,8.629,8.629,0,0,1-2.065-2.714,12.419,12.419,0,0,1-1.136-3.9,7.555,7.555,0,0,1,.216-4.213,6.428,6.428,0,0,1,1.4-2.084,5.393,5.393,0,0,1,1.9-1.286,2.952,2.952,0,0,0,.962-.583c.72-.673.92-1.565,1.357-3.517a18.512,18.512,0,0,0,.4-3.4,28.257,28.257,0,0,0-.51-5.942c-.072-.382-.142-.7-.206-1a16.755,16.755,0,0,1-.385-2.456,9.338,9.338,0,0,1-.034-1.17c.007-.3.016-.677-.021-1.545-.013-.317-.029-.6-.042-.855a6.652,6.652,0,0,1,.256-2.967c.19-.526.638-1.756,1.721-1.866,1.2-.13,1.917,1.224,2.223,1.8a10.221,10.221,0,0,1,1,4.882c.016.365.033.754.056,1.175.035.633.055.792.1,1.178.059.478.158,1.276.367,3.624l.065.739c.139,1.588.216,2.463.451,3.806a9.078,9.078,0,0,0,.824,3.092c.151.248.311.46.48.685a8.829,8.829,0,0,1,1.093,1.771,10.278,10.278,0,0,1,.633,1.782,12.6,12.6,0,0,1,.343,4.144,13.272,13.272,0,0,1-.622,3.108,12.276,12.276,0,0,1-.657,1.58,6.938,6.938,0,0,0-.583,1.551,4.352,4.352,0,0,0-.251,1.767c.083.453.671,1.251,4.368,3.994l.592.436a6.006,6.006,0,0,1,1,.831,7.988,7.988,0,0,1,2.032,4.8,13.021,13.021,0,0,1-.818,5c-.173.612-.335,1.105-.476,1.531a4.576,4.576,0,0,0-.391,2.2,6.518,6.518,0,0,0,.676,2.078,5.4,5.4,0,0,0,.448.671l-1.459,1.139a7.343,7.343,0,0,1-.6-.9,8.367,8.367,0,0,1-.9-2.758,6.235,6.235,0,0,1,.47-3.014c.134-.4.288-.873.451-1.45a11.5,11.5,0,0,0,.757-4.341,6.163,6.163,0,0,0-1.54-3.706,4.33,4.33,0,0,0-.746-.6l-.6-.441c-4.128-3.061-4.879-4.024-5.087-5.146a5.735,5.735,0,0,1,.273-2.536,8.78,8.78,0,0,1,.714-1.92,10.547,10.547,0,0,0,.569-1.363,11.628,11.628,0,0,0,.533-2.669,10.7,10.7,0,0,0-.288-3.524,8.578,8.578,0,0,0-.522-1.476,7.062,7.062,0,0,0-.89-1.435,9.777,9.777,0,0,1-.585-.837,10.372,10.372,0,0,1-1.066-3.736c-.249-1.421-.332-2.378-.471-3.963l-.065-.736c-.206-2.316-.3-3.095-.36-3.56-.05-.4-.075-.608-.115-1.3-.023-.43-.041-.828-.057-1.2a8.621,8.621,0,0,0-.781-4.088,5.249,5.249,0,0,0-.385-.633c-.056.118-.119.272-.187.46a5.123,5.123,0,0,0-.147,2.234c.013.262.03.552.044.876.04.929.03,1.34.022,1.669a7.543,7.543,0,0,0,.028.976,15.225,15.225,0,0,0,.35,2.218c.067.312.14.648.215,1.046a30.134,30.134,0,0,1,.541,6.348,20.414,20.414,0,0,1-.443,3.745c-.474,2.121-.76,3.4-1.9,4.465a4.718,4.718,0,0,1-1.481.925,3.6,3.6,0,0,0-1.325.884,4.571,4.571,0,0,0-1.014,1.489,5.779,5.779,0,0,0-.1,3.245,10.585,10.585,0,0,0,.965,3.349,6.849,6.849,0,0,0,1.679,2.192,7.809,7.809,0,0,1,1.954,2.607,10.315,10.315,0,0,1,.927,4.261c.028,1.548.067,3.669-1.368,5.131a3.787,3.787,0,0,1-1.766,1,1.717,1.717,0,0,0-1.05.647,4.57,4.57,0,0,0-.813,2.287,19.318,19.318,0,0,0,.007,2.182c.027.967.048,1.688.084,1.855a2.94,2.94,0,0,0,1.035,1.521c.26.259.554.551.866.915a10.408,10.408,0,0,1,2.416,4.915c.251,1.505-.048,2.8-.589,5.137a7.421,7.421,0,0,1-1.172,3.045,4.847,4.847,0,0,1-1.24,1.109,5.48,5.48,0,0,0-1.069.894,7.077,7.077,0,0,0-1.25,1.9,8.5,8.5,0,0,0-.6,3.58,9.163,9.163,0,0,0,.184,2.547,5.424,5.424,0,0,0,.9,1.882c.343.536.768,1.2,1.333,2.264a12.635,12.635,0,0,1,1.509,3.564,6.388,6.388,0,0,1-.546,4.721,3.386,3.386,0,0,1-1.214,1.159,5.778,5.778,0,0,0-.981.751,10.308,10.308,0,0,0-2.261,3.649c-.958,2.1-1.277,2.871-1.047,3.809a3.913,3.913,0,0,0,.919,1.577,5.55,5.55,0,0,0,1.652,1.351,13.829,13.829,0,0,1,2.244,1.648,5.419,5.419,0,0,1,1.832,2.332,5.27,5.27,0,0,1-.219,3.566,7.885,7.885,0,0,1-1.81,2.661,10.686,10.686,0,0,1-1.934,1.718,2.631,2.631,0,0,0-.862.841,7.006,7.006,0,0,0-.8,3.409,8.657,8.657,0,0,0,.075,3.3c.371,1.347,1.3,2.3,3.34,4.377a6,6,0,0,0,5.9,2.613c1.383.076,2.308.1,3.84.141l2.8.077c1.288.037,1.672.049,2.493.043.947-.006,3.539-.253,5.255-.417.906-.086,1.629-.155,1.894-.17l.1,1.849c-.254.014-.95.081-1.819.164-1.853.177-4.39.418-5.42.425Z",
    transform: "translate(-1604.022 -578.387)",
    fill: "#81afcc"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data.8b5e6aba.svg";
export { ForwardRef as ReactComponent };